<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Edit"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Fund Bucket
            </h4>
            <p class="category font-weight-thin">
              Edit Fund Bucket
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form v-if="dialog">
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                v-model="localFundBucket.name"
                v-validate="'required'"
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name" 
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-combobox
                v-model="localFundBucket.group"
                v-validate="'required'"
                :error-messages="errors.collect('group')"
                data-vv-name="group" 
                :items="groups"
                label="Group"
              />
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      fundBucket: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,           
        groups: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

        name: '',
        group: 0,
        localFundBucket: null,
        progressing: false,
      }
    },
    computed: {
      isDataChanged () {
        return _.isEqual(this.fundBucket, this.localFundBucket)
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localFundBucket = { ...this.fundBucket }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            if (!this.isDataChanged) {
              this.$api.fundBuckets().update(this.fundBucket.id, this.prepareFormData())
                .then((response) => {
                  if (response.status === 200) {
                    this.$emit('updated')
                    this.$snack({ color: 'success', message: response.data.message })

                    this.dialog = false
                  }
                }).catch((err) => {
                  console.log(err)
                  this.$snack({ color: 'error', message: err.response.statusText })
                }).then(() => {
                  this.progressing = false
                })
            } else {
              this.$snack({ color: 'warning', message: 'No update has been done' })
              this.progressing = false
              this.dialog = false
            }
          })
      },
      prepareFormData () {
        return {
          name: this.localFundBucket.name,
          group: this.localFundBucket.group,
        }
      },
    },
  }
</script>
